// removed by extract-text-webpack-plugin
module.exports = {"payment-type-container":"payment-type-filter-field__payment-type-container___a0iBA","shared-select":"payment-type-filter-field__shared-select___1R0Ai","lastFourDigits":"payment-type-filter-field__lastFourDigits___3ftyy","payment-title":"payment-type-filter-field__payment-title___zerFY","digits-title":"payment-type-filter-field__digits-title___3zkIf"};


//////////////////
// WEBPACK FOOTER
// ./src/scss/components/documents/payment-type-filter-field.scss
// module id = 1331
// module chunks = 0